export default __webpack_public_path__ + "static/media/laerdal.50386039.png";